import { render, staticRenderFns } from "./autInformation.vue?vue&type=template&id=dbb21988&scoped=true"
import script from "./autInformation.vue?vue&type=script&lang=js"
export * from "./autInformation.vue?vue&type=script&lang=js"
import style0 from "./autInformation.vue?vue&type=style&index=0&id=dbb21988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb21988",
  null
  
)

export default component.exports